import { createFileRoute } from "@tanstack/react-router"

import { MarketingMailingFormPage } from "@/pages/marketing-mailing-form"

export const Route = createFileRoute("/(marketing)/marketing/mailings/$taskId")(
	{
		staticData: {
			breadcrumbKey: "navigation.breadcrumbs.mailingEdit",
		},
		component: function MailingsEditRoute() {
			const { taskId } = Route.useParams()
			return <MarketingMailingFormPage mode="edit" taskId={taskId} />
		},
	},
)
